import { memo, useEffect, useState } from 'react';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import CauHinhHeThongService from 'src/services/CauHinhHeThong.service';
import TaiKhoanService from 'src/services/TaiKhoan.service';
import { useCauHinhHeThong, useTaiKhoan } from 'src/stores';
import { IBaseProps } from 'src/types/common.type';
import CONTANTS from 'src/utils/constants';

const svTaiKhoan = new TaiKhoanService();
const svCauHinh = new CauHinhHeThongService();

function InitAppProvider({ children }: IBaseProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  // const { refresh } = useRefresh();
  const { doiTaiKhoan } = useTaiKhoan();
  const { datCauHinh } = useCauHinhHeThong();

  useEffect(() => {
    fetchInit();
  }, []);

  const fetchInit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const account = await svTaiKhoan.thongTinCaNhan();
      const cauHinh = await svCauHinh.list({ take: CONTANTS.PAGE_SIZE_MAX });
      doiTaiKhoan(account);
      datCauHinh(cauHinh.data);

      setInit(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  if (loading || !init) return <SpinnerLoader bg={false} />;

  return children;
}

export default memo(InitAppProvider);
